module.exports = __webpack_public_path__ + "fonts/noto-sans-v7-latin-70087fdfdebee12871ec0b2c04217f6f603.woff2";